import { render, staticRenderFns } from "./zoom.vue?vue&type=template&id=b10b326a&scoped=true"
import script from "./zoom.vue?vue&type=script&lang=js"
export * from "./zoom.vue?vue&type=script&lang=js"
import style0 from "./zoom.vue?vue&type=style&index=0&id=b10b326a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b10b326a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b10b326a')) {
      api.createRecord('b10b326a', component.options)
    } else {
      api.reload('b10b326a', component.options)
    }
    module.hot.accept("./zoom.vue?vue&type=template&id=b10b326a&scoped=true", function () {
      api.rerender('b10b326a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/design/layout/zoom.vue"
export default component.exports